import React, { useEffect } from "react";

import { Card, CardHeader, CardMedia, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Toolbar } from '@material-ui/core';
import { RouteComponentProps } from "@reach/router";
import AppPage from "../../components/AppFrame/AppPage";
import { useQueryParams, StringParam, withDefault } from "use-query-params";

import { actions } from '../../services/photos';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import CustomGrid from "../../components/CustomGrid";
import { getPhotoFile, ProfileAvatar } from "../../components/UserPhoto/UserPhoto";
import { UserPhoto } from "../../types";
import timeAgo from "../../utils/timeAgo";
import { Box } from "@material-ui/system";

import ErrorIcon from '@material-ui/icons/Error';



const PhotosList: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.photos);
  const users = useSelector((state: RootState) => state.users);


  const [ filters, setFilters ] = useQueryParams({
    status: withDefault(StringParam, 'all'),
    source: withDefault(StringParam, 'all'),
  });

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilters({
      [ event.target.name ]: event.target.value
    }, 'replaceIn');
  };

  useEffect(() => {
    dispatch(actions.loadList(filters as any, false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters ]);

  const loadMorePhotos = () => {
    console.log('loading more photos...');
    dispatch(actions.loadList(filters as any, true));
  }

  return (
    <AppPage title="Photos" loading={state.loading}>
      <Card variant="outlined" sx={{ width: '100%', padding: '10px 0px' }}>
        <Toolbar>
          <Stack direction="row" spacing={2}>
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="source-label">Source</InputLabel>
              <Select
                name="source"
                labelId="source-label"
                value={filters.source}
                label="Source"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="device_gallery">Device gallery</MenuItem>
                <MenuItem value="device_camera">Device camera</MenuItem>
                <MenuItem value="facebook">Facebook</MenuItem>
                <MenuItem value="google">Google</MenuItem>
                <MenuItem value="other">Other</MenuItem>

              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="source-label">Status</InputLabel>
              <Select
                name="status"
                labelId="status-label"
                value={filters.status}
                label="Status"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="deleted">Deleted</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="pendimg_import">Pendimg import</MenuItem>
                <MenuItem value="disapproved">Disapproved</MenuItem>
                <MenuItem value="failed">Failed</MenuItem>
                <MenuItem value="account_deleted">Account deleted</MenuItem>
                <MenuItem value="account_disabled">Account disabled</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Toolbar>
      </Card>

      <CustomGrid
        id="user-photos"
        onLoadMore={loadMorePhotos}
        items={state.photos}
        itemWidth={280}
        itemHeight={375}
        spacing={10}
        isLoadingMore={state.loadingMore}
        // alignToCenter
        onRenderItem={(photo: UserPhoto) => {
          const file = getPhotoFile(photo);
          const userName = users.users[ photo.userId ]?.firstName ?? '';
          const addTime = timeAgo(photo.createTime.toDate());

          return (
            <Card variant="outlined">
              <CardHeader
                avatar={
                  <ProfileAvatar userId={photo.userId} />
                }
                title={userName}
                subheader={`${addTime} - ${photo.status}`}
              />

              {
                file ? (
                  <a href={`${process.env.REACT_APP_CDN_URL}/${file.path}`} target="_blank" rel="noreferrer">
                    <CardMedia
                      component="img"
                      height={375 - 82}
                      image={`${process.env.REACT_APP_CDN_URL}/${file.path}`}
                      alt="Paella dish"
                    />
                  </a>
                ) : (
                  <Box sx={{ width: 280, height: 375 - 82, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <ErrorIcon fontSize="large" color="error"/>
                  </Box>

                )
              }


            </Card>
          )
        }}
      />

    </AppPage>
  );
};

export default PhotosList;